import { firestore } from "common/Firebase";
import BatchService from "common/services/BatchService";
import * as firebase from "firebase/app";
import { WBSModels } from "modules/WBS/WBSModels";

import { FirebaseDocument } from "common/models/FirebaseDocument";
import { TaskRows } from "modules/WBS/models/TaskRows";
import { Location } from "modules/WBS/models/Location";

export class WBSTasks {
  code: string;
  description: string;
  unitCost: Number;
  unit: string;
  origin: string;
  disabled: string;
  childrenCount: Number;
  locations:
    | Array<FirebaseDocument<Location>>
    | Promise<firebase.firestore.QuerySnapshot>;
  taskRows:
    | Array<FirebaseDocument<TaskRows>>
    | Promise<firebase.firestore.QuerySnapshot>;

  constructor(
    code: string,
    description: string,
    unitCost: Number,
    unit: string,
    origin: string,
    disabled: string,
    childrenCount: Number,
    ref?: firebase.firestore.DocumentReference
  ) {
    this.code = code;
    this.description = description;
    this.unitCost = unitCost;
    this.unit = unit;
    this.origin = origin;
    this.disabled = disabled;
    this.childrenCount = childrenCount;
    if (ref) {
      this.locations = new Promise((resolve, reject) => {
        ref
          .collection("locations")
          .get()
          .then((snapshot) => {
            this.locations = snapshot.docs.map((row) =>
              WBSModels.locations(row)
            );
            resolve();
          });
      });
      this.taskRows = new Promise((resolve, reject) => {
        let taskRowsRef = ref.collection("taskRows");
        taskRowsRef.get().then(async (snapshot) => {
          let rows = new Array(),
            actions = new Array();
          for (let row of snapshot.docs) {
            let data = row.data();
            if (data.disabled) {
              let rowRef = taskRowsRef.doc(row.id),
                contentRef = firestore
                  .doc(data.contentReference.path)
                  .collection("locations"),
                location = await contentRef
                  .where("path", "==", rowRef.path)
                  .limit(1)
                  .get();
              actions.push({ type: "delete", args: [rowRef] });
              if (location.docs[0])
                actions.push({ type: "delete", args: [location.docs[0].ref] });
            } else rows.push(WBSModels.taskRows(row));
          }
          this.batch(actions);
          this.taskRows = rows;
          resolve();
        });
      });
    } else {
      this.locations = [];
      this.taskRows = [];
    }
  }
  public static getDefault(): WBSTasks {
    return new WBSTasks("", "", 0, "", "", "", 0);
  }

  batch(actions) {
    return BatchService.apply(actions);
  }
}



// WEBPACK FOOTER //
// ./src/modules/WBS/models/WBSTasks.tsx